import React, { useState } from 'react'
import { columns, mobileColumns } from './Column'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import { Alert } from 'react-bootstrap'
import ReportFooter from '../../ReportsFooter/ReportFooter'
const WmrcResponseTimeTable = ({
    isLoading,
    WmrcResponseTime,
    DisplayDate,
    downloadExcel,
    reportData,
    reportCode,
    reportTableData,
    downloadPDF
}) => {
    const [currentRow, setCurrentRow] = useState(null)
    const size = useWindowSize()
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-2">WMRC Response Time</h1>
                <h6 className="text-muted mb-4 fw-normal">
                    The grid below shows WMRC response time for {DisplayDate?.startDate} and
                    {DisplayDate?.endDate}.
                </h6>
                <ReactExpandableTable
                    isLoading={isLoading}
                    setCurrentRow={setCurrentRow}
                    currentRow={currentRow}
                    data={WmrcResponseTime}
                    mobileColumns={mobileColumns}
                    removePagination={true}

                />
                {/* {WmrcResponseTime?.length <= 0 ?
                    <Alert variant={'danger'} className="my-4" dismissible>
                        No Record Found
                    </Alert>
                    : null
                } */}

                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                    MailText={'Mail'}
                    ExcelText={'Excel'}
                    reportData={reportData}
                    reportCode={reportCode}
                    reportTableData={reportTableData}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-2">WMRC Response Time</h1>
            <h6 className="text-muted mb-4 fw-normal">
                The grid below shows WMRC response time for {DisplayDate?.startDate} and {DisplayDate?.endDate}.
            </h6>
            <ReactDataTable
                isLoading={isLoading}
                data={WmrcResponseTime}
                columns={columns}
                removePagination={true}
            />
            {/* {WmrcResponseTime?.length <= 0 ?
                <Alert variant={'danger'} className="my-4" dismissible>
                    No Record Found
                </Alert>
                : null
            } */}

            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                MailText={'Mail'}
                ExcelText={'Excel'}
                reportData={reportData}
                reportCode={reportCode}
                reportTableData={reportTableData}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
            />
        </>
    )
}

export default WmrcResponseTimeTable
